/**
 * 拖动排序列表组件
 */
import React from 'react';
import HTML5Backend from "react-dnd-html5-backend";
import {Scrollbars} from "react-custom-scrollbars";
import {Table} from "antd";
import {DndProvider, DragSource, DropTarget} from "react-dnd";
import moveIcon from "../../view/components/storySortModal/image/icon_5@2x.png";
import BaseComponent from "../../base/BaseComponent";

let dragIndex = -1;

class BodyRow extends React.Component {
    render() {
        const {isOver, connectDragSource, connectDropTarget, moveRow, ...restProps} = this.props;
        const style = {...restProps.style, cursor: 'move'};

        let {className} = restProps;
        if (isOver) {
            if (restProps.index > dragIndex) {
                className += ' drop-over-downward';
            }
            if (restProps.index < dragIndex) {
                className += ' drop-over-upward';
            }
        }

        return connectDragSource(
            connectDropTarget(<tr {...restProps} className={className} style={style}/>),
        );
    }
}

const rowSource = {
    beginDrag(props) {
        dragIndex = props.index;
        return {
            index: props.index,
        };
    },
};

const rowTarget = {
    drop(props, monitor) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Time to actually perform the action
        props.moveRow(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    },
};

const DragBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))(
    DragSource('row', rowSource, connect => ({
        connectDragSource: connect.dragSource(),
    }))(BodyRow),
);

export default class DragSortTable extends BaseComponent {
    static propTypes = {};
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            sortList: [],
            mediaId: props.mediaId,
            treeContentId: props.treeContentId,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getSortColumns();
        this.getSortList();
    }

    getSortColumns = () => {
        const sortColumns = [
            {
                title: "图片",
                dataIndex: "url",
                width: 180,
                align: "center",
                render: (url) => {
                    return url ? <img src={url} width={58} height={38} style={{objectFit: "contain"}}/> : "-";
                }
            },
            {
                title: "名称",
                dataIndex: "name",
                width: 180,
                ellipsis: true,
                render: (text, record) => {
                    let ico;
                    // 判断是显示移动端还是PC端ico
                    if (record.clientTypes && record.clientTypes.length === 1) {
                        if (record.clientTypes.indexOf(0) > -1) {
                            ico = record.ico
                        } else if (record.clientTypes.indexOf(1) > -1) {
                            ico = record.mobileIco
                        }
                    } else if (record.clientTypes && record.clientTypes.length > 1) {
                        if (record.clientTypes.indexOf(0) > -1) {
                            ico = record.ico
                        }
                    }
                    if (ico) {
                        return <div style={{
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <div
                                style={{
                                    flex: "0 0 18px",
                                    height: "18px",
                                    backgroundImage: `url(${ico})`,
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    marginRight: "8px"
                                }}
                            >
                            </div>
                            <span>{text}</span>
                        </div>;
                    } else if (!(record.ico || record.mobileIco) && record.svg || record.mobileSvg) {
                        return (
                            <>
                                <div className={'iconStyle'} style={{
                                    display: "flex",
                                    alignItems: "center"
                                }}>
                                    <div style={{
                                        flex: "0 0 18px",
                                        height: "18px",
                                        width: "18px",
                                        marginRight: "8px"
                                    }}
                                         dangerouslySetInnerHTML={{__html: record.svg || record.mobileSvg}}
                                    />
                                    <span>{text}</span>
                                </div>
                                <style>{`
                                .iconStyle .icon{
                                    height: 18px !important;
                                    width: 18px !important;
                                    vertical-align: sub;
                                }
                                `}</style>
                            </>
                        )
                    } else {
                        return <span>{text}</span>;
                    }
                }
            },
            {
                title: "编码",
                dataIndex: "columnCode",
                width: 180,
                ellipsis: true
            },
            {
                title: "类型",
                dataIndex: "type",
                width: 160,
                render: (text) => {
                    let map = {
                        "1": "普通栏目",
                        "2": "专题栏目",
                        "3": "视频栏目",
                    };
                    return map[text];
                }
            },
            {
                title: "操作",
                width: 160,
                render: (text, record) => {
                    return <>
                        <img alt={"拖动排序"} src={moveIcon} style={{width: 20, marginTop: -2, marginRight: 5}}/>
                        <span style={{color: '#0050B3'}}>拖动排序</span>
                    </>
                }
            }
        ];
        this.setState({
            sortColumns
        });
    };

    getSortList() {
        this.request({
            url: "/cm-sites-mmp/column/all",
            body: {
                fid: ["0", "0-0"].indexOf(this.state.treeContentId) > -1 ? "" : this.state.treeContentId,
                mediaId: this.state.mediaId
            },
            method: "post",
            callBack: data => {
                let sortList = [];
                if (data && data.length) {
                    sortList = data;
                    sortList.forEach(item => {
                        item.code = item.columnCode;
                        item.name = item.columnName;
                        item.menuCode = item.columnCode;
                        item.menuName = item.columnName;
                    });
                }
                this.setState({
                    sortList
                })
            }
        });
    }

    components = {
        body: {
            row: DragBodyRow,
        },
    };

    /**
     * 拖拽排序
     * @param dragIndex 拖拽行下标
     * @param hoverIndex 换到行的下标
     * dragIndex > hoverIndex 从下往上拖，反之从上往下拖
     * 从上往下拖 1，2，3
     *      1->2 2->3 3->1
     * 从下往上 1，2，3
     *      3->1 1->2 2->3
     */
    moveRow = (dragIndex, hoverIndex) => {
        const {sortList} = this.state;
        const {orderField} = this.props; //排序字段
        if (dragIndex < hoverIndex) {
            for (let index = dragIndex; index < hoverIndex; index++) {
                let indexRow = sortList[index];
                let indexRowOrder = indexRow[orderField];

                let nextIndex = index + 1;
                if (nextIndex > hoverIndex) {
                    nextIndex = dragIndex;
                }
                let nextRow = sortList[nextIndex];
                // 交换排序字段
                indexRow[orderField] = nextRow[orderField];
                nextRow[orderField] = indexRowOrder;

                // 交换下标
                sortList[index] = nextRow;
                sortList[nextIndex] = indexRow;
            }
        } else {
            for (let index = dragIndex; index > hoverIndex; index--) {
                let indexRow = sortList[index];
                let indexRowOrder = indexRow[orderField];

                let prevIndex = index - 1;
                if (prevIndex < hoverIndex) {
                    prevIndex = hoverIndex;
                }
                let preRow = sortList[prevIndex];
                // 交换排序字段
                indexRow[orderField] = preRow[orderField];
                preRow[orderField] = indexRowOrder;

                // 交换下标
                sortList[index] = preRow;
                sortList[prevIndex] = indexRow;
            }
        }
        this.setState({sortList});
    };

    render() {
        let {sortColumns, sortList} = this.state;
        return (
            <DndProvider backend={HTML5Backend}>
                <Scrollbars autoHeight autoHide autoHeightMax={600}>
                    <Table
                        id={'storyTable'}
                        rowKey="id"
                        columns={sortColumns}
                        dataSource={sortList}
                        components={this.components}
                        onRow={(record, index) => ({
                            index,
                            moveRow: this.moveRow,
                        })}
                        pagination={false}
                    >
                    </Table>
                </Scrollbars>
                <style>
                    {`#storyTable .ant-table-tbody .ant-table-row{border-bottom:1px solid #e8e8e8 } #storyTable .ant-table-content .ant-table-body table {border-collapse:collapse ! important}`}
                </style>
            </DndProvider>
        )
    }
}